import ArrowIcon from "@/components/icons/ArrowIcon";
import { useRouter } from "next/router";
import { useState } from "react";

const Brands = ({ data, code, selectedFilterKeys, handleFilter, t }) => {
  const [showMore, setShowMore] = useState(false);
  const { push } = useRouter();

  return (
    <ul className="flex flex-col gap-7 max-sm:gap-4 max-sm:mt-3">
      {Array.isArray(data)
        ? data?.slice(0, showMore ? data?.length : 11)?.map((item, key) =>
            item?.DocCount && item?.Label && item?.Key ? (
              <li
                key={key}
                className="flex items-center text-sm gap-3 max-sm:gap-2 cursor-pointer text-[#586A84] border-gray-600"
                onClick={() => {
                  code == "category_ids"
                    ? push(`/${item?.url_key}`)
                    : handleFilter({
                        code,
                        item,
                      });
                }}
              >
                <div className="flex gap-2">
                  <input
                    type="checkbox"
                    id={`${code}-${item?.Key}`}
                    defaultChecked={
                      selectedFilterKeys?.includes(`${code}=${item?.Key}`)
                    }
                    // checked={selectedFilterKeys?.includes(
                    //   `${code}=${item?.Key}`
                    // )}
                    className={`
                      relative peer shrink-0
                      appearance-none size-4 max-sm:size-3.5 cursor-pointer border border-[#586A84] rounded-sm bg-white
                      ${
                        selectedFilterKeys?.includes(`${code}=${item?.Key}`)
                          ? "checked:bg-green-700 checked:border-0"
                          : ""
                      }
                    `}
                  />
                  <svg
                    className={`
                      absolute 
                      size-4 
                      hidden ${
                        selectedFilterKeys?.includes(`${code}=${item?.Key}`)
                          ? "peer-checked:block"
                          : ""
                      }`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <span htmlFor={`${code}-${item?.Key}`} className="max-sm:text-xs">
                  {item?.Label}
                </span>
                <span
                  htmlFor={`${code}-${item?.Key}`}
                  className="text-[#BAC4D1] max-sm:text-xs"
                >
                  ({item?.DocCount})
                </span>
              </li>
            ) : null
          )
        : null}
      {data?.length > 10 ? (
        <li
          className="mb-0 flex items-center gap-1.5 text-[#586A84] cursor-pointer text-sm max-sm:text-xs"
          onClick={() => setShowMore(!showMore)}
        >
          {!showMore ? (
            <span>{t("Show More")}</span>
          ) : (
            <span>{t("Show Less")}</span>
          )}
          <ArrowIcon
            className={`size-3 transition-all ${
              showMore ? "-rotate-90" : "rotate-90"
            } mt-1`}
          />
        </li>
      ) : null}
    </ul>
  );
};

export default Brands;
